import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "menuIsOpen", "onCloseMenuRequest", "onOpenMenuRequest", "ariaProps", "label", "noPopup"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useRef } from 'react';
import { ButtonBase } from '@mui/material';
// eslint-disable-next-line react/display-name
export var EmbersMenuLaunchButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    menuIsOpen = props.menuIsOpen,
    onCloseMenuRequest = props.onCloseMenuRequest,
    onOpenMenuRequest = props.onOpenMenuRequest,
    ariaProps = props.ariaProps,
    label = props.label,
    noPopup = props.noPopup,
    restProps = _objectWithoutProperties(props, _excluded);
  var buttonRef = useRef(null);
  var isOpenRef = useRef(false);
  useEffect(function () {
    isOpenRef.current = menuIsOpen;
  }, [menuIsOpen]);
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    if (isOpenRef.current) {
      isOpenRef.current = false;
      onCloseMenuRequest();
    } else {
      isOpenRef.current = true;
      // @ts-ignore
      onOpenMenuRequest((ref === null || ref === void 0 ? void 0 : ref.current) || buttonRef.current);
    }
  };
  return /*#__PURE__*/React.createElement(ButtonBase, _extends({
    ref: ref || buttonRef,
    onClick: handleClick,
    disableRipple: true,
    className: className || '',
    "aria-label": label || (ariaProps === null || ariaProps === void 0 ? void 0 : ariaProps['aria-label']),
    "aria-expanded": menuIsOpen ? 'true' : (ariaProps === null || ariaProps === void 0 ? void 0 : ariaProps['aria-expanded']) || 'false',
    "aria-haspopup": noPopup ? 'false' : 'true'
  }, ariaProps, restProps), children);
});